import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from "rxjs";
import {filter, map, switchMap, take} from "rxjs/operators";
import {Store} from '@ngrx/store';
import {selectIsHydrated, selectUserAuthentication} from '../../store/auth/auth.selectors';

/**
 * AuthGuard
 *
 * Waits for the hydration attempt (HttpOnly-cookie refresh) to complete before
 * deciding whether the user is authenticated. This prevents the race condition
 * where a page-refresh triggers a redirect to login before the /refresh call
 * has had a chance to restore the in-memory access token.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectIsHydrated).pipe(
      filter(isHydrated => isHydrated),
      take(1),
      switchMap(() => this.store.select(selectUserAuthentication).pipe(take(1))),
      map(authentication => {
        if (!authentication?.token) {
          this.router.navigate(['/auth/login']);
          return false;
        }
        return true;
      })
    );
  }
}
